import { Controller } from "@hotwired/stimulus"

// チェックボックス群の全選択トグルと選択数カウンタ。
// targets: toggle(全選択チェックボックス), item(各候補チェックボックス), count(選択数表示)
export default class extends Controller {
  static targets = ["toggle", "item", "count"]

  connect() {
    this.refresh()
  }

  // 全選択チェックボックスの状態を各項目へ反映する。
  toggleAll() {
    const checked = this.toggleTarget.checked
    this.itemTargets.forEach((item) => { if (!item.disabled) item.checked = checked })
    this.refresh()
  }

  // 個別チェックの変更時に全選択状態とカウンタを更新する。
  refresh() {
    const selectable = this.itemTargets.filter((item) => !item.disabled)
    const selected = selectable.filter((item) => item.checked)
    if (this.hasCountTarget) this.countTarget.textContent = selected.length
    if (this.hasToggleTarget) {
      this.toggleTarget.checked = selectable.length > 0 && selected.length === selectable.length
      this.toggleTarget.indeterminate = selected.length > 0 && selected.length < selectable.length
    }
  }
}
